import { FIELD_VALIDATION_RULES } from "../consts/validationRule";
import { changeInput } from "../../utils/helpers/validateFields";

const handleChangeFullName = (setFullNameErrorText, setUserFullName) => event => {
  // TODO: upgrade to RHF
  const value = event.target.value;

  const options = [
    {
      type: FIELD_VALIDATION_RULES.EMPTY_LENGTH,
      targets: [value],
      refs: [event.target],
      error: "Поле не может быть пустым",
      setter: setFullNameErrorText,
    },
  ];

  changeInput(value, setUserFullName, options);
};

export default handleChangeFullName;
